import { c as _c } from "react/compiler-runtime";
import { Button, Icon, InlineNotification } from "@justhome/react-ui";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
interface FormSectionProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  formId?: string;
  canGoBack?: boolean;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const FormSection = t0 => {
  const $ = _c(26);
  const {
    children,
    title,
    description,
    formId,
    canGoBack: t1,
    onGoBack,
    isLoading,
    isError
  } = t0;
  const canGoBack = t1 === undefined ? true : t1;
  const {
    t
  } = useBookingTranslation();
  let t2;
  if ($[0] !== title) {
    t2 = title && <h2 className="text-h2 font-semibold">{title}</h2>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== description) {
    t3 = description && <p>{description}</p>;
    $[2] = description;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isError || $[5] !== t) {
    t4 = isError && <InlineNotification type="error" icon={<Icon type="Attention" />} className="mb-s">{t("formSection.error")}</InlineNotification>;
    $[4] = isError;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== canGoBack || $[8] !== onGoBack || $[9] !== t) {
    t5 = canGoBack && <Button variant="ghost" iconStart="Left" size="md" onClick={onGoBack}>{t("formSection.back")}</Button>;
    $[7] = canGoBack;
    $[8] = onGoBack;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("formSection.continue");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== formId || $[14] !== isLoading || $[15] !== t6) {
    t7 = <Button variant="primary" form={formId} type="submit" iconEnd="Right" size="md" shadow={true} className="ml-auto" fullWidth={true} isLoading={isLoading}>{t6}</Button>;
    $[13] = formId;
    $[14] = isLoading;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="flex mt-2s">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== children || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t8) {
    t9 = <section className="space-y-m w-[600px] max-w-full">{t2}{t3}{children}{t4}{t8}</section>;
    $[20] = children;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
export default FormSection;